// types
import { ExchangeRateByDate } from '../../../@types';

// 1i8n
import { useTranslation } from 'react-i18next';

// mui
import { Box, BoxProps, Grid, InputLabel, Typography } from '@mui/material';

// ui
import { AlertExchangeRates } from '../../ui/AlertExchangeRates/AlertExchangeRates';
import { ExchangeRate } from './ExchangeRate/ExchangeRate';

// theme
import { theme } from '../../../theme';

// props
export interface ExchangeRatesProps {
	alertPosition?: 'top' | 'bottom';
	BoxProps?: BoxProps;
	currencyBase: string;
	exchangeRates: ExchangeRateByDate[];
	hasAlert?: boolean;
	hasLabel?: boolean;
	onChange: (index: number, name: string, value: string | number) => void;
	required?: boolean;
}

export const ExchangeRates = ({
	alertPosition = 'top',
	BoxProps,
	currencyBase,
	exchangeRates = [],
	hasAlert = true,
	hasLabel = true,
	onChange,
	required = true,
}: ExchangeRatesProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const currenciesForExchangeRates = exchangeRates.map((er) => er.currency);

	if (!exchangeRates.length) {
		return null;
	}

	const alert = (
		<AlertExchangeRates
			currency={currencyBase}
			currenciesForExchangeRates={currenciesForExchangeRates}
		/>
	);

	return (
		<Grid container spacing={2}>
			{hasAlert && currencyBase && alertPosition === 'top' && (
				<Grid item xs={12}>
					{alert}
				</Grid>
			)}
			<Grid item xs={12}>
				<Grid container>
					{hasLabel && (
						<Grid item xs={12}>
							<InputLabel required={required}>{t('exchangeRates')}</InputLabel>
						</Grid>
					)}
					<Grid item xs={12}>
						<Box
							sx={{
								borderColor: theme.palette.divider,
								borderRadius: 2,
								borderStyle: 'solid',
								borderWidth: 1,
								padding: theme.spacing(2),
								...BoxProps?.sx,
							}}
							{...BoxProps}>
							<Grid container spacing={2}>
								{exchangeRates.map((exchangeRate, index) => (
									<Grid item xs={12} key={index}>
										<ExchangeRate
											currencyBase={currencyBase}
											exchangeRate={exchangeRate}
											index={index}
											onChange={onChange}
										/>
									</Grid>
								))}
							</Grid>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Typography color="textSecondary" variant="caption">
							{t('exchangeRates.helper')}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			{hasAlert && currencyBase && alertPosition === 'bottom' && (
				<Grid item xs={12}>
					{alert}
				</Grid>
			)}
		</Grid>
	);
};
